import { useEffect, useState } from "react";
import "./Rdmap.css"; // CSS 파일 추가 필요
let map;
let selectedMarker = null; // 선택된 마커
let markers = []; // 검색 결과 마커들
let createSelectedMarker; // 전역 함수로 선언

function KakaoMap(props) {
  const [searchResults, setSearchResults] = useState([]);
  const scles = props.scle.split("^");
  // console.log(scles)
  const wd = scles[0] * 1;
  const ht = scles[1] * 1;

  const new_script = (src) => {
    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = src;
      script.addEventListener("load", () => {
        resolve();
      });
      script.addEventListener("error", (e) => {
        reject(e);
      });
      document.head.appendChild(script);
    });
  };

  useEffect(() => {
    //카카오맵 스크립트 읽어오기
    const my_script = new_script(
      'https://dapi.kakao.com/v2/maps/sdk.js?appkey=b7967dc1f2c2b6f788a029bc7b701f09&libraries=services,clusterer,drawing"'
    );
    //스크립트 읽기 완료 후 카카오맵 설정
    my_script.then(() => {
      console.log("script loaded!!!");
      const kakao = window["kakao"];
      kakao.maps.load(() => {
        const mapContainer = document.getElementById("map");
        const options = {
          center: new kakao.maps.LatLng(37.884878, 127.729656), //좌표설정
          level: 3,
        };

        const ismap = !map; // 처음에만 맵 생성
        const iscor = props.newcoor.length == 0; // 좌표값이 없으면 맵 생성

        if (ismap || iscor) {
          // 처음에만 맵 생성
          map = new kakao.maps.Map(mapContainer, options); //맵생성
          //지도종류 선택
          const mapTypeControl = new kakao.maps.MapTypeControl();
          map.addControl(mapTypeControl, kakao.maps.ControlPosition.TOPRIGHT);
          //스카이뷰를 기본값으로 설정
          map.setMapTypeId(kakao.maps.MapTypeId.HYBRID);
        }

        // 검색 서비스 초기화
        const ps = new kakao.maps.services.Places();
        const geocoder = new kakao.maps.services.Geocoder();
        const searchInput = document.getElementById("rdv-search");

        // 이전 마커들 제거 함수
        const removeMarkers = () => {
          for (let i = 0; i < markers.length; i++) {
            markers[i].setMap(null);
          }
          markers = [];
        };

        // 검색 결과 마커 생성
        const displayMarker = (place) => {
          const marker = new kakao.maps.Marker({
            map: map,
            position: new kakao.maps.LatLng(place.y, place.x),
          });
          markers.push(marker);
        };

        // 선택한 위치 마커 생성 함수를 전역으로 할당
        createSelectedMarker = (lat, lon) => {
          if (selectedMarker) {
            selectedMarker.setMap(null);
          }
          selectedMarker = new kakao.maps.Marker({
            map: map,
            position: new kakao.maps.LatLng(lat, lon),
            fillColor: "#FF0000", // 빨간색으로 설정
            fillOpacity: 1,
            strokeWeight: 0,
          });
        };

        // 키워드 검색 콜백
        const placesSearchCB = (data, status, pagination) => {
          if (status === kakao.maps.services.Status.OK) {
            removeMarkers();
            let bounds = new kakao.maps.LatLngBounds();

            const results = data.map((place) => ({
              name: place.place_name,
              address: place.address_name,
              roadAddress: place.road_address_name,
              y: place.y,
              x: place.x,
            }));
            setSearchResults(results);

            for (let i = 0; i < data.length; i++) {
              displayMarker(data[i]);
              bounds.extend(new kakao.maps.LatLng(data[i].y, data[i].x));
            }
            map.setBounds(bounds);
          } else {
            setSearchResults([]);
            removeMarkers();
          }
        };

        // 검색 이벤트 핸들러
        if (searchInput) {
          searchInput.addEventListener("keydown", (e) => {
            if (e.keyCode === 13) {
              e.preventDefault();
              const keyword = searchInput.value;
              ps.keywordSearch(keyword, placesSearchCB);
            }
          });
        }

        // 지도 클릭 이벤트
        window.kakao.maps.event.addListener(map, "click", (mouseEvent) => {
          const latlng = mouseEvent.latLng;
          let lat = latlng.getLat().toFixed(6);
          let lon = latlng.getLng().toFixed(6);

          geocoder.coord2Address(
            latlng.getLng(),
            latlng.getLat(),
            (result, status) => {
              if (status === kakao.maps.services.Status.OK) {
                const addr = result[0].address.address_name.replace(
                  "강원특별자치도 ",
                  ""
                );
                props.clickedvalue(lat, lon, addr);
                createSelectedMarker(lat, lon);
              } else {
                props.clickedvalue(lat, lon, "주소없음");
                createSelectedMarker(lat, lon);
              }
            }
          );
        });

        //마커설정
        const markerPosition = new kakao.maps.LatLng(37.884878, 127.729656);
        const marker = new kakao.maps.Marker({
          position: markerPosition,
        });
        marker.setMap(map);

        //기존자료 좌표있으면 마커위치 이동
        const newcoor = props.newcoor;
        const newlat = newcoor[0];
        const newlon = newcoor[1];
        const newlatlng = new kakao.maps.LatLng(newlat, newlon);
        if (newlat != undefined) {
          // console.log(props.newcoor);
          map.setCenter(newlatlng);
          marker.setPosition(newlatlng);
        }
      });
    });
  }, [props.newcoor]);

  return (
    <div style={{ position: "relative" }}>
      <div id="map" style={{ width: wd, height: ht }} />
      <div className="search-container">
        <input
          type="text"
          id="rdv-search"
          className="search-input"
          placeholder="주소, 장소, 키워드로 검색"
        />
        {searchResults.length > 0 && (
          <div className="search-results">
            {searchResults.map((result, index) => (
              <div
                key={index}
                className="search-result-item"
                onClick={() => {
                  if (
                    window.kakao &&
                    window.kakao.maps &&
                    createSelectedMarker
                  ) {
                    const coords = new window.kakao.maps.LatLng(
                      result.y,
                      result.x
                    );
                    map.setCenter(coords);

                    // 선택한 위치에 빨간색 마커 생성
                    if (selectedMarker) {
                      selectedMarker.setMap(null);
                    }

                    // 마커 이미지 설정
                    const markerImage = new window.kakao.maps.MarkerImage(
                      "https://t1.daumcdn.net/mapjsapi/images/2x/marker.png",
                      new window.kakao.maps.Size(29, 42),
                      {
                        offset: new window.kakao.maps.Point(14, 42),
                        alt: "marker",
                        shape: "poly",
                        coords:
                          "1,20,1,9,5,2,10,0,18,0,23,2,27,9,27,20,27,35,14,42,1,35",
                      }
                    );

                    selectedMarker = new window.kakao.maps.Marker({
                      map: map,
                      position: coords,
                      image: markerImage,
                    });

                    props.clickedvalue(result.y, result.x, result.address);
                  }
                }}
              >
                <div className="result-name">{result.name}</div>
                <div className="result-address">
                  {result.roadAddress || result.address}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default KakaoMap;
